import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-01-07
	insertBatch(params) {
		return axios.post('/mms/receives/insert-batch', params)
	},
	// 2021-01-07
	search(params) {
		return axios.get('/mms/receives?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-01-08
	batchQuality(params) {
		return axios.put('/mms/receives/batch-quality', params)
	},
	// 2021-01-08
	return(id) {
		return axios.put('/mms/receives/' + id + '/return')
	},
	// 2021-01-08
	confirmStorage(id, params) {
		return axios.put('/mms/receives/' + id + '/confirm-storage', params)
	},
	// 2021-03-13
	batchConfirmStorage(params) {
		return axios.put('/mms/receives/batch-confirm-storage', params)
	},

	// 2021-01-08
	unQualityCount(params) {
		return axios.get('/mms/receives/un-quality-count', params);
	},
	// 2021-01-08
	unStorageCount(params) {
		return axios.get('/mms/receives/un-storage-count', params);
	}
}
